import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.whatYouGet.heading',
		defaultMessage: "What you'll get",
		description: 'Calm Schools section heading',
	},
	para1: {
		id: 'schools.whatYouGet.para1',
		defaultMessage: 'Age-specific resources to help you bring mindfulness into the classroom',
		description: 'Calm Schools benefit description text',
	},
	para2: {
		id: 'schools.whatYouGet.para2',
		defaultMessage: 'A self-care guide to support you during the school day and beyond',
		description: 'Calm Schools benefit description text',
	},
	para3: {
		id: 'schools.whatYouGet.para3',
		defaultMessage: 'A free sampling of meditations, music, Sleep Stories, breathing exercises and more',
		description: 'Calm Schools benefit description text',
	},
	button: {
		id: 'schools.whatYouGet.button',
		defaultMessage: 'Get Started',
		description: 'Calm Schools Get Started call to action text',
	},
});
